var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeadOfficePin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.999 65a17.953 17.953 0 0 0-1.595-7.234 18.101 18.101 0 0 0-4.385-5.996L28.833 47.1a16.748 16.748 0 0 1-4.065-5.608 16.611 16.611 0 0 1-1.436-6.756c0-9.12 7.463-16.61 16.667-16.61s16.666 7.488 16.666 16.608a16.68 16.68 0 0 1-5.5 12.364l-5.188 4.671a18.104 18.104 0 0 0-4.386 5.996A17.963 17.963 0 0 0 39.999 65Zm0-24.859a5.074 5.074 0 0 1-3.572-1.465 4.98 4.98 0 0 1-1.479-3.538c0-1.327.532-2.6 1.48-3.538a5.074 5.074 0 0 1 3.57-1.466c1.34 0 2.625.527 3.572 1.465a4.98 4.98 0 0 1 1.48 3.539 4.98 4.98 0 0 1-1.48 3.538 5.074 5.074 0 0 1-3.571 1.465Z",
    stroke: "url(#a)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 23.332,
    y1: 41.539,
    x2: 56.665,
    y2: 41.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19636B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadOfficePin);
export default __webpack_public_path__ + "static/media/headOfficePin.6e886e7a5ba1eeed4df677e8e03bf220.svg";
export { ForwardRef as ReactComponent };